/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_WpmInputs */



/**
* | output |
* | --- |
* | "Words per minute out of range" |
*
* @param {Qc_Fix_WpmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_wpm = /** @type {((inputs?: Qc_Fix_WpmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_WpmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mots par minute hors limites")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wörter pro Minute außerhalb des Bereichs")
	if (locale === "it") return /** @type {LocalizedString} */ ("Parole al minuto fuori intervallo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слов в минуту вне диапазона")
	if (locale === "es") return /** @type {LocalizedString} */ ("Palabras por minuto fuera de rango")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每分钟词数超出范围")
	if (locale === "ja") return /** @type {LocalizedString} */ ("毎分語数が範囲外です")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रति मिनट शब्द सीमा से बाहर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Palavras por minuto fora do intervalo")
	return /** @type {LocalizedString} */ ("Words per minute out of range")
});